import React from 'react';
import { Empty, Button } from 'antd';
import {
  InboxOutlined,
  FileTextOutlined,
  WalletOutlined,
  CloudUploadOutlined,
  WifiOutlined,
} from '@ant-design/icons';

const PRESETS = {
  data: {
    icon: <InboxOutlined style={{ fontSize: 64, color: 'var(--sj-primary-300)' }} />,
    title: '暂无数据',
    description: '还没有记录呢，开始创建第一条吧',
    action: '立即创建',
  },
  bill: {
    icon: <WalletOutlined style={{ fontSize: 64, color: 'var(--sj-primary-300)' }} />,
    title: '暂无账单记录',
    description: '导入或手动添加账单，开启智能记账',
    action: '导入账单',
  },
  report: {
    icon: <FileTextOutlined style={{ fontSize: 64, color: 'var(--sj-primary-300)' }} />,
    title: '暂无报告',
    description: '记录时间后，自动生成分析报告',
    action: '新建报告',
  },
  search: {
    icon: <InboxOutlined style={{ fontSize: 64, color: 'var(--sj-primary-300)' }} />,
    title: '没有找到匹配结果',
    description: '换个关键词试试，或创建一条新记录',
    action: null,
  },
  network: {
    icon: <WifiOutlined style={{ fontSize: 64, color: 'var(--sj-primary-300)' }} />,
    title: '网络连接异常',
    description: '请检查网络后刷新页面',
    action: '刷新页面',
  },
  upload: {
    icon: <CloudUploadOutlined style={{ fontSize: 64, color: 'var(--sj-primary-300)' }} />,
    title: '暂无文件',
    description: '拖拽文件到此处，或点击上传',
    action: '选择文件',
  },
  write: {
    icon: <FileTextOutlined style={{ fontSize: 64, color: 'var(--sj-primary-300)' }} />,
    title: '暂无语写记录',
    description: '还没有语写记录，登录后即可开始创作 🌱',
    action: '立即登录',
  },
  login: {
    icon: <InboxOutlined style={{ fontSize: 64, color: 'var(--sj-primary-300)' }} />,
    title: '请先登录',
    description: '登录后查看您的专属数据',
    action: '立即登录',
  },
};

/**
 * 统一空状态组件
 * @param {string} preset - 预设类型: data|bill|report|search|network|upload
 * @param {string} title - 自定义标题（覆盖预设）
 * @param {string} description - 自定义描述（覆盖预设）
 * @param {string} actionText - 自定义按钮文字（覆盖预设）
 * @param {function} onAction - 按钮点击回调
 * @param {ReactNode} customIcon - 自定义图标（覆盖预设）
 */
const EmptyState = ({
  preset = 'data',
  title,
  description,
  actionText,
  onAction,
  customIcon,
  style,
}) => {
  const config = PRESETS[preset] || PRESETS.data;

  return (
    <Empty
      image={customIcon || config.icon}
      description={
        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              fontSize: 16,
              fontWeight: 600,
              color: 'var(--sj-text-primary, #1a1a1a)',
              marginBottom: 8,
            }}
          >
            {title || config.title}
          </div>
          <div
            style={{
              fontSize: 14,
              color: 'var(--sj-text-secondary, #666666)',
              marginBottom: 16,
              lineHeight: 1.6,
            }}
          >
            {description || config.description}
          </div>
          {onAction && (
            <Button
              type="primary"
              onClick={onAction}
              style={{
                background: 'var(--sj-primary, #2196f3)',
                borderColor: 'var(--sj-primary, #2196f3)',
                borderRadius: 8,
                color: '#fff',
                minWidth: 120,
                height: 40,
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              {actionText || config.action}
            </Button>
          )}
        </div>
      }
      style={{
        padding: '60px 20px',
        ...style,
      }}
    />
  );
};

export default EmptyState;
